/*eslint-disable */

import AccountStore from './suAccountStore'
import AlgorithmStore from './algorithm'
import ChatBot from './chatBot'
import ConfrenceStore from './confrenceStore'
import DataWellStore from './dataWell'
import EmailStore from './emailStore'
import MeetingStore from './meetingStore'
import Profile from './profile'
import SuperAdminAccountStore from './saAccount'
import TaskStore from './task'
import UserStore from './userStore'
import VideoStore from './videoStore'
import Vue from 'vue';
import Vuex from 'vuex';
import aiTaskStore from './aiTaskStore'
import algoDataStore from './algoDataStore'
import authenticationStore from './authenticate'
import blogStore from './blogStore'
import botTicketStore from './botTicketStore'
import briefcaseStore from './briefcaseStore'
import chatMessageCache from './modules/chatMessageCache';
import consultRequestStore from './consultRequestStore'
import employeeStore from './employeeStore'
import eventStore from './eventStore'
import interviewStore from './interviewStore'
import lbilAdminStore from './lbilAdminStore'
import lbilFilterStore from './lbilFilterStore'
import lbilStore from './lbilStore'
import loader from './loaderStore'
import lymphomapAdminStore from './lymphomapAdminStore'
import memberFiltersStore from './memberFiltersStore'
import memberStore from './memberStore'
import notesStore from './notesStore'
import notificationStore from './notificationStore'
import paperPileStore from './paperPileStore'
import rListUsersStore from './rListUsersStore'
import schedulerStore from './schedulerStore'
import subscriptionPlanStore from './subscriptionPlanStore'
import todoStore from './todoStore.js';
import twoFactorStore from './twoFactorStore'
import unsubscribedStore from './unsubscribedStore'
import webinarStore from './webinarStore'
import workspaceStore from './workspaceStore'

export const strict = false
Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    authenticationStore,
    chatMessageCache,
    AlgorithmStore,
    DataWellStore,
    AccountStore,
    TaskStore,
    SuperAdminAccountStore,
    ChatBot,
    Profile,
    UserStore,
    VideoStore,
    EmailStore,
    ConfrenceStore,
    MeetingStore,
    webinarStore,
    memberStore,
    blogStore,
    memberFiltersStore,
    notesStore,
    algoDataStore,
    briefcaseStore,
    unsubscribedStore,
    aiTaskStore,
    workspaceStore,
    schedulerStore,
    employeeStore,
    rListUsersStore,
    consultRequestStore,
    subscriptionPlanStore,
    todoStore,
    twoFactorStore,
    lbilStore,
    lymphomapAdminStore,
    paperPileStore,
    notificationStore,
    interviewStore,
    eventStore,
    lbilFilterStore,
    lbilAdminStore,
    botTicketStore,
    loader
  }
})